export default __webpack_public_path__ + "static/cddo-f5b5c13d92d270cf65f8c9538e07a5fa.png";